import { getDataString } from "../../util/Months";

const data = new Date()

const InitialDashboardEquipamento ={
    isLoadingCards: false,
    isLoadingDays: false,
    isAutoplayEnabled: true,
    cards:{
        0: [
            {
                "Active": false,
                "type": 0,
                "focus": true,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            },
            {
                "Active": false,
                "type": 0,
            }
        ],
        1:[
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
            {
                "Active": false,
                "type": 1,
            },
        ]
    },
    name: '',
    hasMoreCards: {
        0: false,
        1: false,
    },
    days: [],
    day: getDataString(data.getDate()),
    month: getDataString(data.getMonth()+1),
    year: data.getFullYear(),
    Equipamentos: [],
    equipment: '',
    cities: [],
    city: '',
    Mode: 0,
    CardStatus: 0,
    updateCardIcon: false,
}

export default function DashboardEquipamentoReducer ( PrevState = InitialDashboardEquipamento, action){
    switch (action.type) {
        case 'ChangeEquipamentoCards':
            return{
                ...PrevState,
                cards : action.payload.cards,
                name : action.payload.name
            };
        case 'ChangeTotalCards':
            return{
                ...PrevState,
                hasMoreCards : {
                    ...PrevState.hasMoreCards,
                    ...action.payload.hasMoreCards
                },
            };
        case 'ChangeDays' :
            return{
                ...PrevState,
                days: action.payload.days
            };
        case 'ChangeDay':
            return {
                ...PrevState,
                day: action.payload.day
            };
        case 'ChangeMonth':
            return {
                ...PrevState,
                month: action.payload.month
            };
        case 'ListEquipamentos' :
            return {
                ...PrevState,
                Equipamentos: action.payload.equipamentos
            };
        case 'ChangeCardsLoading' :
            return{
                ...PrevState,
                isLoadingCards : action.payload.isLoading
            };
        case 'ChangeDaysLoading' :
            return{
                ...PrevState,
                isLoadingDays : action.payload.isLoading
            };
        case 'ChangeAutoplay':
            return {
                ...PrevState,
                isAutoplayEnabled: action.payload.isAutoplayEnabled
            };
        case 'changeyear':
            return {
                ...PrevState,
                year: action.payload.year
            };
        case 'ChangeMode':
            return {
                ...PrevState,
                Mode: action.payload.mode
            };
        case 'ChangeStatus':
            return {
                ...PrevState,
                CardStatus: action.payload.status
            };
        case 'ChangeCardIcon':
            return {
                ...PrevState,
                updateCardIcon: action.payload.change
            };
        case 'ListCities':{
            return {
                ...PrevState,
                cities: action.payload.cities
            }
        }
        case 'ChangeCity':{
            return{
                ...PrevState,
                city: action.payload.city
            }
        }
        case 'ChangeEquipment':{
            return{
                ...PrevState,
                equipment: action.payload.equipment
            }
        }
        default:
            return PrevState;
    }
}